<template>
  <div v-if="(attachmentsCount > 0)">
    <br/>
    <div v-if="showAttachments">
      <strong>Liitteet: </strong>
      <div v-for="attachment in query.attachments" :key="attachment.id">
        <a :href="`/storage/${attachment.filename}`" target="_blank">{{ attachment.filename }} <i class="fa fa-external-link"></i></a>
      </div>
    </div>
    <div v-else>
      <div class="text-muted">
        <small>
          {{ attachmentsCount }}
          {{ attachmentsCount == 1 ? 'liite' : 'liitettä' }}
        </small
      ></div>
    </div>
  </div>
</template>

<script>

import { userMixin } from '@/mixins/userMixin.js'

export default {

  mixins: [
    userMixin,
  ],

  props: {
    query: Object,
    currentUser: Object,
  },

  computed: {
    showAttachments() {
      return this.isStaff(this.currentUser) || this.query.user_id == this.currentUser.id
    },

    attachmentsCount() {
      return this.query.attachments.length
    },
  },


}

</script>

<style scoped>
  
</style>
